import { z } from 'zod'

export const MEMBERSHIP_I18N_SEED_CONTRACT_VERSION = '1.0.0' as const

export const membershipI18nSeedResponseSchema = z.object({
  ok: z.boolean(),
}).passthrough()

export type MembershipI18nSeedResponse = z.infer<typeof membershipI18nSeedResponseSchema>
